import {Component, Inject, Input, OnInit} from '@angular/core';
import {ConfService} from "../../conf.service";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AttributesListComponent} from "../../attributes-list/attributes-list.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ConnecttocrudService} from "../../connecttocrud.service";
import {ViewDialogComponent} from "../../api-new/api-new.component";
import {ActivatedRoute} from "@angular/router";
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {GetPasswordComponent} from "../connectors/connectors.component";
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {AccountInfoService} from '../../user/account-info.service';

declare let $;

@Component({
  selector: 'app-logging-settings',
  templateUrl: './logging-settings.component.html',
  styleUrls: ['./logging-settings.component.scss']
})
export class LoggingSettingsComponent implements OnInit {

  constructor(public confPost: ConfService,
              public _service: ConnecttocrudService,
              public platform: LeftpanelComponent,
              public dialog: MatDialog,
              public accountInfoService: AccountInfoService,
              public snackBar: MatSnackBar,
              public route: ActivatedRoute) { }
  selectedVault: any;
  showConfigureButton = true;
  vault: any;
  platformSecrets: any;
  partnerSecrets: any;
  paramFlag: any;
  flag: any;
  viewData: any;
  count: any;
  keys: any;
  paramTitle: any;
  paramProvider: any;
  isError: any;
  @Input() partner = '';
  @Input() account = '';
  @Input() data: any;
  @Input() provider: any;
  @Input() id: any;
  @Input() title: any;
  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
                  if (this.provider !== undefined && this.title !== undefined) {
                    this.paramFlag = true;
                  } else {
                    this.viewData = [];
                    this.keys = [];
                    this.paramFlag = false;
                    this._service.getItemswithParameter('v1','services', 'services','secretmanagers', 'partner=services&account=services').subscribe(data => {
                      this.platformSecrets = data;
                      this._service.getItemswithParameter('v1','services','services','secretmanagers','partner=' +  this.partner + '&account=' + this.account).subscribe(data1 => {
                        this.partnerSecrets = data1;
                        this.confPost.getPartnerByName(this.partner).subscribe(resp => {
                          this.confPost.getCountforSecrets(this.partner , this.account, resp['partnerKey']).subscribe(res => {
                            this.count = res;
                            this.flag = true;
                          }, error => {
                            this.flag = true;
                            this.isError = true;
                          });
                        }, error => {
                          this.flag = true;
                          this.isError = true;
                        });
                      }, error => {
                        this.flag = true;
                        this.isError = true;
                      });
                    }, error => {
                      this.flag = true;
                      this.isError = true;
                    });
                  }
  }
  extractkey(val) {
    return Object.keys(val)[0];
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
  View(data) {
    const dialogRef = this.dialog.open(GetPasswordComponent, {
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  goBack() {
    this.provider = '';
    this.title = '';
    this.paramFlag = false;
    this.flag = true;
  }
  setFunc(val1, val2) {
    this.provider = val1;
    this.title = val2;
    this.confPost.getBulkSecrets(this.partner, this.account, this.provider, this.title).subscribe ( data => {
      this.viewData = data;
      this.keys = Object.keys(this.viewData.data);
      this.paramFlag = true;
    });
  }
  Delete(name) {
    if (confirm('Are you sure you want to delete?')) {
      this.confPost.deleteSecrets(this.partner, this.account, this.title, this.provider, name).subscribe(data => {
        window.location.reload();
      });
    }
  }
  addSecret(title, provider) {
    const dialogRef = this.dialog.open(AddSecretComponent, {
      data: {
        'partner' : this.partner,
        'account_id': this.account,
        'title': title,
        'provider': provider
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  openImport() {
    const dialogRef = this.dialog.open(AddVaultComponent, {
      data: {
        'partner' : this.partner,
        'account_id': this.account,
        'setting_data': this.data,
        'id': this.id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.partnerSecrets.push(result);
      }
    });
  }
}

@Component({
  selector: 'addVault',
  templateUrl: './addVault.component.html',
  styleUrls: ['./addVault.component.scss']
})

export class AddVaultComponent implements OnInit {
  constructor(private confPost: ConfService,
              public platform: LeftpanelComponent,
              public dialogRef: MatDialogRef <AddVaultComponent>,
              private attributeList: AttributesListComponent,
              private _service: ConnecttocrudService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dialogRef.disableClose = true;
  }
  datainitial: any;
  dataFlag = false;
  infoFlag = true;
  selectedVault: any;
  payLoad = {
    'account': '',
    'partner': '',
    'image': '',
    'organisation': '',
    'connection': [],
    'organisationLogo': '',
    'providerName': '',
    'title': '',
    'caption':''
  };
  ngOnInit(): void {
    this.payLoad.account = this.data.account;
    this.payLoad.partner = this.data.partner;
    this._service.getItemswithParameter('v1','services','services','secretmanagers','account=services&partner=services').subscribe(data=> {
      this.datainitial = data;
      this.dataFlag = true;
    });
  }
  close() {
    this.dialogRef.close();
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
  construct() {
    this.payLoad.connection = [];
      for (let i = 0; i < this.selectedVault.connection.length; i++) {
        this.payLoad.connection.push({'key': this.selectedVault.connection[i].key, 'value': ''});
      }
      this.payLoad.image = this.selectedVault.image;
  }
  selectVault(index) {
      this.selectedVault = this.datainitial[index];
      this.payLoad.providerName = this.selectedVault.providerName;
    this.construct();
      // this.initialise();
      // this.settingsPayload.partner_settings.vault = this.selectedVault['name'];
      for (let i = 0; i < this.datainitial.length; i++) {
        const id = 'vault' + i;
        if (index === i) {
          $('#' + id).css('border', '3px solid #ff672d');
        } else {
          $('#' + id).css('border', 'transparent');
        }
      }
  }
  proceedToImport()
  {
    this.payLoad['owner'] = this.data.partner;
    this._service.addItem(this.payLoad, 'v1','services','services','secretmanagers').subscribe(data => {
      if (!this.data.partner.includes('admin-') && !this.data.account.includes('admin-')) {
        this.confPost.getSettingsV2CRUD(this.data.partner, this.data.account_id, false).subscribe(data1 => {
          this.payLoad['default'] = true;
          this.payLoad['audit_logs'] = [];
          if (data1['body'] && data1['body'][0] && data1['body'][0]['environments']) {
            for (let i = 0 ; i < data1['body'][0]['environments'][0]['services'].length; i++) {
              if (data1['body'][0]['environments'][0]['services'][i]['type'] === 'secretsmanager') {
                data1['body'][0]['environments'][0]['services'][i]['configurations'].push(this.payLoad);
              }
            }
          }
          this.confPost.patchItemServices('v2', 'settings', data1['body'][0], data1['body'][0]['id']).subscribe(succcess => {
            if (this.data.setting_data && this.data.setting_data.length > 0) {
              for (let j = 0; j < this.data.setting_data.length; j++) {
                if (this.data.setting_data[j]['name'] === this.data.partner) {
                  for (let i = 0; i < this.data.setting_data[j]['services'].length; i++) {
                    if (this.data.setting_data[j]['services'][i]['type'] === 'secretsmanager') {
                      this.data.setting_data[j]['services'][i]['configurations'].push(this.payLoad);
                    }
                  }
                }
              }
            }
            this.confPost.patchItemServices('v2', 'settings', {environments: this.data.setting_data}, this.data.id).subscribe(success => {
              this.platform.openSnackBar('Succesfull', 'Success', {
                duration: 1500,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            }, error => {
              this.platform.openSnackBar('There was an error. Please try again after sometime', 'Error', {
                duration: 1500,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            });
          }, error => {
            this.platform.openSnackBar('There was an error. Please try again after sometime', 'Error', {
              duration: 1500,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          });
        }, error => {
          this.platform.openSnackBar('There was an error. Please try again after sometime.', 'Error', {
            duration: 1500,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      } else  {
        this.payLoad['default'] = true;
        this.payLoad['audit_logs'] = [];
        if (this.data.setting_data && this.data.setting_data.length > 0) {
          for (let j = 0; j < this.data.setting_data.length; j++) {
            if (this.data.setting_data[j]['name'] === this.data.partner) {
              for (let i = 0; i < this.data.setting_data[j]['services'].length; i++) {
                if (this.data.setting_data[j]['services'][i]['type'] === 'secretsmanager') {
                  this.data.setting_data[j]['services'][i]['configurations'].push(this.payLoad);
                }
              }
            }
          }
        }
        this.confPost.patchItemServices('v2', 'settings', {environments: this.data.setting_data}, this.data.id).subscribe(success => {
          this.platform.openSnackBar('Successful', 'Success', {
            duration: 1500,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }, error => {
          this.platform.openSnackBar('Successful', 'Success', {
            duration: 1500,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        });
      }
    }, err => {
      this.platform.openSnackBar('Error while configuring secrets manager. Please try again after sometime', 'Error', {
        duration: 1500,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }
}

@Component({
  selector: 'addSecret',
  templateUrl: './addSecret.component.html',
  styleUrls: ['./addSecret.component.scss']
})

export class AddSecretComponent implements OnInit {
  constructor(private confPost: ConfService,
              public platform: LeftpanelComponent,
              public dialogRef: MatDialogRef <AddVaultComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dialogRef.disableClose = true;
  }
  platformSecrets: any;
  partnerSecrets: any;
  parameters = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  payLoad = {
    "data": {},
    "name": '',
    "providerName": this.data.provider,
    "attributes": {}
  };
  add(event, data): void {
      const input = event.input;
      const value = event.value;

      if ((value || '').trim()) {
        data.push(value.trim());
        this.payLoad.data[value] = '';
      }
      if (input) {
        input.value = '';
      }
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
  remove(val, data): void {
      const index = data.indexOf(val);
      delete this.payLoad.data[val];
      if (index >= 0) {
        data.splice(index, 1);
      }
  }
  Add() {
    this.confPost.insertSecret(this.data.partner, this.data.account_id, this.data.title, this.payLoad).subscribe(success =>{
      this.platform.openSnackBar('Secret stored successfully', 'Success', {
        duration: 1500,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.dialogRef.close();
    });
  }
  close () {
    this.dialogRef.close();
  }
  ngOnInit() {
  }
}
